import PageHeroSectionWithImageAtTheTop from "./_components/page-hero-section-with-image-at-the-top";

export default PageHeroSectionWithImageAtTheTop;
